<script>
  import { onMount } from "svelte";
  import request from 'superagent';
  import { createEventDispatcher } from 'svelte';
  
  const dispatch = createEventDispatcher();
  
  export let form_id = window.FEED_FORM_ID;
  
  export let feed = {uri: "", name: "", format: "", xpath: ""};
  
  function commit() {
    let submit = request.post;
    submit(`/form/${form_id}`)
    .send(feed)
    .then(resp => {
      dispatch('feed', Object.assign(feed, {id: resp.body.id}))
    });
  }
  
  function cancel() {
    dispatch('cancel');
  }
  
  onMount(() => {
    feed = Object.assign({uri: "", name: "", format: "", xpath: ""}, feed);
  });
</script>
<form action='/form/{form_id}' class='form'>
<div class='row'>
<fieldset class='form-group col-12'>
<label class='form-text text-muted' for='feed-name'>Název zdroje</label>
<input bind:value='{feed.name}' class='form-control ui' id='feed-name' type='text'>
</fieldset>
<fieldset class='form-group col-12'>
<label class='form-text text-muted' for='feed-uri'>Adresa zdroje</label>
<input bind:value='{feed.uri}' class='form-control ui' id='feed-uri' type='text'>
</fieldset>
<div class='col-12 d-flex justify-content-between'>
<button class='btn btn-outline-primary border-0' on:click|preventDefault='{commit}' type='submit'>uložit</button>
<button class='btn btn-outline-secondary border-0' on:click|preventDefault='{cancel}' type='reset'>zpět</button>
</div>
</div>
</form>

